import { FC } from 'react'
import { Typography } from '@mui/material'
import { DialogNames } from 'src/enums'
import { SensorModal } from './sensorModal'

interface Props {
  projectName: string
  onSubmit: () => void
  onCancel: () => void
  isLoading?: boolean
}

export const ReassignInUseSensorModal: FC<Props> = ({ projectName, onSubmit, onCancel, isLoading = false }) => {
  return (
    <SensorModal
      dialogName={DialogNames.ReassignInUseSensor}
      onSubmit={onSubmit}
      onCancel={onCancel}
      isLoading={isLoading}
      actionButtonName="Reassign"
      content={
        <Typography variant="h6">
          Attention: The sensor you're going to reassign will be disconnected from the {projectName} project. Are you sure you want to proceed?
        </Typography>
      }
    />
  )
}
